import axios from "axios";

export default axios.create({
    withCredentials: true,
    //baseURL:'/services/api/',                               // remote server
    //baseURL:'https://149.50.132.93/services/api/',        // remote server from local react
    //baseURL:'http://127.0.0.1/services/api/',             // local server
    baseURL:'https://www.henrycotacto.com/services/api/',        // remote server from local react
    responseEncoding:'UTF-8'
})